var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { DisplayContent, LoadingIndicator } from '../../../index';
// TODO: Convert file to tsx
var LongPlayCollections = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var config = _a.config, longPlayGame = _a.longPlayGame, revealToken = _a.revealToken, actions = _a.actions, promotion = _a.promotion;
    var _q = useState(false), iframeLoaded = _q[0], setIframeLoaded = _q[1];
    var _r = useState(null), boardId = _r[0], setBoardId = _r[1];
    var _s = useState(null), gameUrl = _s[0], setGameUrl = _s[1];
    var gameId = (_b = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.game) === null || _b === void 0 ? void 0 : _b.id;
    var gameServer = (_d = (_c = config === null || config === void 0 ? void 0 : config.config) === null || _c === void 0 ? void 0 : _c.reveal_host) !== null && _d !== void 0 ? _d : '';
    var boards = (_f = (_e = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.boards) === null || _e === void 0 ? void 0 : _e[gameId]) !== null && _f !== void 0 ? _f : [];
    var firstBoardId = (_g = boards === null || boards === void 0 ? void 0 : boards[0]) === null || _g === void 0 ? void 0 : _g.board_serial;
    var winsAndPrizes = (_j = (_h = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.winsAndPrizes) === null || _h === void 0 ? void 0 : _h[gameId]) !== null && _j !== void 0 ? _j : [];
    var gameBoardDetails = (_l = (_k = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.boardDetails) === null || _k === void 0 ? void 0 : _k[boardId]) !== null && _l !== void 0 ? _l : {};
    var getBoardDetails = function (_a) {
        var gameId = _a.gameId, boardId = _a.boardId;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, ((_b = actions === null || actions === void 0 ? void 0 : actions.longPlayActions) === null || _b === void 0 ? void 0 : _b.getBoard({ game_id: gameId, board_id: boardId }))];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (((_b = (_a = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.boards) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) && !((_d = (_c = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.boards) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.gamepieces)) {
            getBoardDetails({ gameId: (_e = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.game) === null || _e === void 0 ? void 0 : _e.id, boardId: (_g = (_f = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.boards) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.board_serial });
            setGameUrl('');
        }
    }, [(_m = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.boards) === null || _m === void 0 ? void 0 : _m.length]);
    useEffect(function () {
        function fetchData() {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, ((_a = actions === null || actions === void 0 ? void 0 : actions.revealTokenActions) === null || _a === void 0 ? void 0 : _a.getRevealToken())];
                        case 1:
                            _d.sent();
                            // single call to the api/game endgine game, corresponding promotion name
                            return [4 /*yield*/, ((_b = actions === null || actions === void 0 ? void 0 : actions.longPlayActions) === null || _b === void 0 ? void 0 : _b.getBoards(gameId))];
                        case 2:
                            // single call to the api/game endgine game, corresponding promotion name
                            _d.sent();
                            return [4 /*yield*/, ((_c = actions === null || actions === void 0 ? void 0 : actions.longPlayActions) === null || _c === void 0 ? void 0 : _c.getWinsAndPrizes(gameId))];
                        case 3:
                            _d.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (gameId) {
            fetchData();
        }
    }, [gameId]);
    useEffect(function () {
        if (gameId) {
            getGameUrl();
        }
    }, [gameId, (_p = (_o = longPlayGame === null || longPlayGame === void 0 ? void 0 : longPlayGame.boardDetails) === null || _o === void 0 ? void 0 : _o[boardId]) === null || _p === void 0 ? void 0 : _p.serial, winsAndPrizes]);
    // Call IGR to get the game URL
    function getGameUrl() {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function () {
            var revealId, gameOutcome, gameOptions, gameData, revealUrl, xhr_1;
            return __generator(this, function (_h) {
                setGameUrl('');
                revealId = (_b = (_a = promotion.playerPromotions[0]) === null || _a === void 0 ? void 0 : _a.reveal) === null || _b === void 0 ? void 0 : _b[0];
                if (gameId && revealToken.revealToken && (gameBoardDetails === null || gameBoardDetails === void 0 ? void 0 : gameBoardDetails.board) && (winsAndPrizes === null || winsAndPrizes === void 0 ? void 0 : winsAndPrizes.length) > 0 && revealId) {
                    gameOutcome = {
                        win_types: winsAndPrizes !== null && winsAndPrizes !== void 0 ? winsAndPrizes : [],
                        game_awards: {},
                        gamepieces: (_d = (_c = gameBoardDetails === null || gameBoardDetails === void 0 ? void 0 : gameBoardDetails.board) === null || _c === void 0 ? void 0 : _c.gamepieces) !== null && _d !== void 0 ? _d : [],
                        wins: (_f = (_e = gameBoardDetails === null || gameBoardDetails === void 0 ? void 0 : gameBoardDetails.board) === null || _e === void 0 ? void 0 : _e.wins) !== null && _f !== void 0 ? _f : [],
                    };
                    gameOptions = {
                        gameId: revealId,
                        serverType: 'Static',
                        outcomeData: gameOutcome,
                        additionalData: {},
                        useMinimized: false,
                    };
                    gameData = 'options=' + encodeURIComponent(JSON.stringify(gameOptions));
                    revealUrl = "".concat(gameServer, "/api/games/url?token=").concat((_g = revealToken.revealToken) !== null && _g !== void 0 ? _g : '');
                    xhr_1 = new XMLHttpRequest();
                    xhr_1.addEventListener('readystatechange', function () {
                        if (xhr_1.readyState === 4) {
                            try {
                                var responseObj = JSON.parse(xhr_1.responseText);
                                setGameUrl(responseObj.gameUrl);
                                window.addEventListener('message', gameEventListener);
                            }
                            catch (err) {
                                console.error('Could not retrieve game URL - ', err);
                            }
                        }
                    });
                    xhr_1.open('POST', revealUrl);
                    xhr_1.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    xhr_1.send(gameData);
                }
                else {
                    console.error('🔴 Reveal token or animation id is not exists');
                }
                return [2 /*return*/];
            });
        });
    }
    useEffect(function () {
        if (firstBoardId) {
            setBoardId(firstBoardId);
        }
    }, [firstBoardId]);
    return (_jsxs(_Fragment, { children: [_jsx(DisplayContent, { isVisible: !iframeLoaded, children: _jsx(LoadingIndicator, { priority: 'low', telescript: { default: ' ' } }) }), _jsx(DisplayContent, { isVisible: gameUrl === null || gameUrl === void 0 ? void 0 : gameUrl.length, children: _jsx("div", { id: 'reveal-game-container', children: _jsx("iframe", { "data-testid": 'gameplay-iframe', title: 'interactive-reveal', className: 'interactive-reveal-iframe', src: gameUrl !== null && gameUrl !== void 0 ? gameUrl : '', onLoad: function () {
                            setIframeLoaded(true);
                        }, allow: 'accelerometer; gyroscope;', frameBorder: '0' }) }) })] }));
};
export default LongPlayCollections;
